import type { InterviewPairingsResponse } from './interviewPairings';
import { getAccessToken } from "../Services/authToken";

// let cachedData: InterviewPairingsResponse | null = null;
const hostname = window.location.hostname;
export const getInterviewPairings = async (
  candidateEmail: string,
  rescheduleClicked: boolean = false
): Promise<InterviewPairingsResponse | null> => {
  // Return cached data if available
  // if (cachedData) {
  //   console.log('[API] Returning cached interview pairings');
  //   return cachedData;
  // }
  
  let baseurl = '';
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl= 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com'; // fallback production
  }

  try {
    // GET TOKEN
    const token = await getAccessToken();
    if (!token) {
      console.error('No authentication token available');
      return null;
    }

    const url = `${baseurl}/api/candidate-dashboard/interview-pairings-2?reschedulePage=${rescheduleClicked}`;
    const res = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json', 'Authorization': `Bearer ${token}` },
    });

    if (!res.ok) {
      throw new Error(`Failed: ${res.status} ${res.statusText}`);
    }

    const data: InterviewPairingsResponse = await res.json();
    console.log('[API] Fetched interview pairings with rescheduled as: ',rescheduleClicked, data);
    
    // Cache the data
    // cachedData = data;
    return data;
  } catch (err) {
    console.error('Error fetching interview pairings:', err);
    return null;
  }
};

// Optional: function to clear cache if needed (e.g., after booking/canceling)
export const clearPairingsCache = () => {
  // cachedData = null;
};